import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseIco = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [/* @__PURE__ */ _jsx("line", {
		x1: 18,
		y1: 6,
		x2: 6,
		y2: 18
	}), /* @__PURE__ */ _jsx("line", {
		x1: 6,
		y1: 6,
		x2: 18,
		y2: 18
	})]
});
export default SvgCloseIco;
